/**
 * Toast Container
 * Wrapper per Sonner Toaster con styling Untitled UI
 */
import { Toaster as SonnerToaster } from "sonner";
import { CheckCircle, XCircle, AlertCircle, InfoCircle } from "@untitledui/icons";

export function ToastContainer() {
    return (
        <SonnerToaster
            position="top-right"
            expand={true}
            richColors={false}
            closeButton
            toastOptions={{
                classNames: {
                    toast: "group toast group-[.toaster]:bg-primary group-[.toaster]:text-secondary group-[.toaster]:border-secondary group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg group-[.toaster]:ring-1 group-[.toaster]:ring-secondary",
                    description: "group-[.toast]:text-tertiary group-[.toast]:text-sm",
                    actionButton: "group-[.toast]:bg-primary group-[.toast]:text-brand-secondary group-[.toast]:font-semibold",
                    cancelButton: "group-[.toast]:bg-primary group-[.toast]:text-tertiary",
                },
            }}
            icons={{
                success: <CheckCircle className="h-5 w-5 text-utility-success-600" />,
                error: <XCircle className="h-5 w-5 text-utility-error-600" />,
                warning: <AlertCircle className="h-5 w-5 text-utility-warning-600" />,
                info: <InfoCircle className="h-5 w-5 text-utility-blue-600" />,
            }}
        />
    );
}
